import { MainImageMedia, ProductMediaOf } from "../types/graphQLTypes";

/**
 * A product's main image, the same one everywhere it is shown outside the PDP gallery (listing cards, cross-sells,
 * fly-to-cart, Yotpo). `gatsby-source-store` picks it into `listing_image` from the backend flag (lifestyle or packshot).
 * Deliberately no further fallback — a product lacking both has no image (the PDP throws at build so it gets noticed).
 */
export const mainProductImage = <T>(media: MainImageMedia<T>): T | undefined => media.listing_image?.[0];

/** `[main image, hover overlay]` — the fly-to-cart animation uses `[0]`. */
export const listingImages = <T extends { fileLocal?: unknown }>(media: MainImageMedia<T> & Pick<ProductMediaOf<T>, "mouse_overlay_image">): T[] => {
  const main = mainProductImage(media);
  return [...(main ? [main] : []), ...(media.mouse_overlay_image ?? [])];
};

/** A bundle's only image: the backend has no packshot/lifestyle fields for bundles yet, so it lives in `gallery_images`. */
export const bundleImages = <T>(media: ProductMediaOf<T>): T[] => media.gallery_images?.slice(0, 1) ?? [];

/** PDP gallery: the product's gallery as the back office orders it. */
export const pdpGalleryImages = <T>(media: ProductMediaOf<T>): T[] => media.gallery_images ?? [];
